module.exports = __webpack_public_path__ + "img/四川天府新区太平镇兴苗幼儿园.564d4f0b.jpg";